import '@emotion/react';
export var ThemeNames;
(function (ThemeNames) {
    ThemeNames["Light"] = "light";
    ThemeNames["Dark"] = "dark";
})(ThemeNames || (ThemeNames = {}));
//# sourceMappingURL=theme.types.js.map